import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Line, Gap, ProgressBar, LabelTitle, LabelLevel, FooterReport } from "../../../../components/Global";
import LoaderModal from "../../../../components/modal/LoaderModal";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import { URL_AKM, CONFIG } from "../../../../config";

const ReportSekolah = (props) => {
    const [dataSchool, SetDataSchool] = useState([]);
    const [dataIndicatorLiterasi, SetDataIndicatorLiterasi] = useState([]);
    const [dataMapelLiterasi, SetDataMapelLiterasi] = useState([]);
    const [dataIndicatorNumerasi, SetDataIndicatorNumerasi] = useState([]);
    const [dataMapelNumerasi, SetDataMapelNumerasi] = useState([]);
    const [dataSurveyCharacter, SetDataSurveyCharacter] = useState([]);
    const [dataSLB, SetDataSLB] = useState([]);
    const [dataFatherEducation, SetDataFatherEducation] = useState([]);
    const [dataMotherEducation, SetDataMotherEducation] = useState([]);
    const [dataHomeFacility, SetDataHomeFacility] = useState([]);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        // axios
        //     .get(
        //         CONFIG_DEV.ACCOUNT_MANAGEMENT_HOST + CONFIG_DEV.GET_REPORT_AKM,
        //         {
        //             params: {
        //                 idJadwal: props.match.params.idJadwal,
        //                 idSekolah: props.match.params.idSekolah,
        //                 idKelas: props.match.params.idKelas,
        //                 idKelasParalel:
        //                     props.match.params.idKelasParalel === "null"
        //                         ? 0
        //                         : props.match.params.idKelasParalel,
        //             },
        //         }
        //     )
        //     .then((result) => {
        //         // console.log(this.props.match.params);
        //         const responseAPI = result.data.data;

        //         SetDataSchool(responseAPI);
        //         SetDataIndicatorLiterasi(
        //             responseAPI.dataIndikator[0].indikator
        //         );
        //         SetDataMapelLiterasi(responseAPI.dataMapel[0].kategories);
        //         SetDataIndicatorNumerasi(
        //             responseAPI.dataIndikator[1].indikator
        //         );
        //         SetDataMapelNumerasi(responseAPI.dataMapel[1].kategories);
        //         SetDataSurveyCharacter(responseAPI.dataNonAkademik.SK);
        //         SetDataSLB(responseAPI.dataNonAkademik.SLB);
        //         SetDataFatherEducation(responseAPI.indekSosial[0].kategori);
        //         SetDataMotherEducation(responseAPI.indekSosial[1].kategori);
        //         SetDataHomeFacility(responseAPI.indekSosial[2].kategori);

        //         console.log("result => ", result);
        //         console.log("param", this.props.match.params);
        //     })
        //     .catch((err) => {
        //         console.log("err => ", err);
        //     });

        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement.get(CONFIG.GET_REPORT_AKM, {
                params: {
                    idJadwal: props.match.params.idJadwal,
                    idSekolah: props.match.params.idSekolah,
                    idKelas: props.match.params.idKelas,
                    idKelasParalel: props.match.params.idKelasParalel === "null" ? 0 : props.match.params.idKelasParalel,
                },
            });
            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log(responseAPI.data);

                    SetDataSchool(responseAPI);
                    SetDataIndicatorLiterasi(responseAPI.dataIndikator[0].indikator);
                    SetDataMapelLiterasi(responseAPI.dataMapel[0].kategories);
                    SetDataIndicatorNumerasi(responseAPI.dataIndikator[1].indikator);
                    SetDataMapelNumerasi(responseAPI.dataMapel[1].kategories);
                    SetDataSurveyCharacter(responseAPI.dataNonAkademik.SK);
                    SetDataSLB(responseAPI.dataNonAkademik.SLB);
                    SetDataFatherEducation(responseAPI.indekSosial[0].kategori);
                    SetDataMotherEducation(responseAPI.indekSosial[1].kategori);
                    SetDataHomeFacility(responseAPI.indekSosial[2].kategori);
                }
                setFetching(false);
            }
        };
        getDatas();
    }, []);

    require("./ReportSekolah.css");
    return (
        <div>
            <LoaderModal isFetching={fetching} />
            {/* page 1 */}
            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Tes : {dataSchool.tanggal}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REPORT {props.match.params.idKelasParalel === "null" ? "PARALEL" : "KELAS"}</div>
                            <div className="label-sub-tit" style={{ width: '380px'}}>
                                <span className="sub-title-header" style={{ color: '#FFF' }}>Program Asesmen Nasional</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-edu">
                                <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                            </div>
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                            </div>
                        </div>
                    </div>

                    <Gap height={40} />
                    {/* card profile */}
                    <div className="pnl-profile">
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Sekolah</span>
                                <p className="label-profile-value">{dataSchool.sekolah}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-kelas.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Kelas</span>
                                <p className="label-profile-value" style={{ verticalAlign: "middle" }}>{props.match.params.idKelasParalel === "null" ? dataSchool.kelas : dataSchool.kelas}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_time.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Tanggal Tes</span>
                                <p className="label-profile-value">{dataSchool.tanggal}</p>
                            </div>
                        </div>
                    </div>
                    {/* card literasi */}
                    <div className="card-profile">
                        <div className="title-card">Literasi</div>
                        <div className="section-one" style={{ paddingLeft: '1%', paddingRight: '1%' }}>
                            <div className="section-one-left">
                                <div>
                                    {dataMapelLiterasi.map((mapelLiterasi, i) => {
                                        return (
                                            <div key={i}>
                                                <div>
                                                    <div
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                            paddingRight: "2%",
                                                        }}
                                                    >
                                                        <ProgressBar
                                                            level={mapelLiterasi.kategori}
                                                            ratio={mapelLiterasi.jumlah + " siswa"}
                                                            progressValue={(Math.round(mapelLiterasi.jumlah * 100) / dataSchool.peserta).toFixed(2)}
                                                            progressColor={mapelLiterasi.kategori === "Mahir" ? "#FF3838" : mapelLiterasi.kategori === "Cakap" ? "#2BA84A" : mapelLiterasi.kategori === "Dasar" ? "#0097CE" : "#5446CD"}
                                                            heightBar={23}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="section-one-right" style={{ marginLeft: '2%', width: '47%' }}>
                                <div style={styles.paddingHorizontal} className="header-table">
                                    <div style={styles.indicator}>
                                        <LabelTitle label={"Indikator"} size={16} bolder={600} color={"#2A2B2A"} />
                                    </div>
                                    <div style={styles.indicatorGreen}>
                                        <div style={{ display: "inline-block" }}>
                                            <LabelTitle label={"Tuntas"} size={16} bolder={600} color={"#2A2B2A"} />
                                        </div>
                                    </div>
                                    <div style={styles.indicatorRed}>
                                        <div style={{ display: "inline-block" }}>
                                            <LabelTitle label={"Tidak Tuntas"} size={16} bolder={600} color={"#2A2B2A"} />
                                        </div>
                                    </div>
                                </div>
                                {dataIndicatorLiterasi.map((indicatorLiterasi, i) => {
                                    return (
                                        <div key={i}>
                                            <div style={styles.paddingHorizontal}>
                                                <div style={styles.indicator}>
                                                    <LabelTitle label={indicatorLiterasi.namaIndikator} size={16} bolder={300} color={"#6C757D"} />
                                                </div>
                                                <div style={styles.indicatorGreen}>
                                                    <div className="indikatorTuntas">
                                                        <LabelTitle label={indicatorLiterasi.tuntas} size={16} bolder={300} color={"#FFF"} />
                                                    </div>
                                                </div>
                                                <div style={styles.indicatorRed}>
                                                    <div className="indikatorTakTuntas">
                                                        <LabelTitle label={indicatorLiterasi.tidakTuntas} size={16} bolder={300} color={"#FFF"} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Gap height={20} />
                    {/* card Numerasi */}
                    <div className="card-profile">
                        <div className="title-card">Numerasi</div>
                        <div className="section-one" style={{ paddingLeft: '1%', paddingRight: '1%' }}>
                            <div className="section-one-left">
                                <div>
                                    {dataMapelNumerasi.map((mapelNumerasi, i) => {
                                        return (
                                            <div key={i}>
                                                <div>
                                                    <div
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                            paddingRight: "2%",
                                                        }}
                                                    >
                                                        <ProgressBar
                                                            level={mapelNumerasi.kategori}
                                                            ratio={mapelNumerasi.jumlah + " siswa"}
                                                            progressValue={(Math.round(mapelNumerasi.jumlah * 100) / dataSchool.peserta).toFixed(2)}
                                                            progressColor={mapelNumerasi.kategori === "Mahir" ? "#FF3838" : mapelNumerasi.kategori === "Cakap" ? "#2BA84A" : mapelNumerasi.kategori === "Dasar" ? "#0097CE" : "#5446CD"}
                                                            heightBar={23}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="section-one-right" style={{ marginLeft: '2%', width: '47%' }}>
                                <div style={styles.paddingHorizontal} className="header-table">
                                    <div style={styles.indicator}>
                                        <LabelTitle label={"Indikator"} size={16} bolder={600} color={"#2A2B2A"} />
                                    </div>
                                    <div style={styles.indicatorGreen}>
                                        <div style={{ display: "inline-block" }}>
                                            <LabelTitle label={"Tuntas"} size={16} bolder={600} color={"#2A2B2A"} />
                                        </div>
                                    </div>
                                    <div style={styles.indicatorRed}>
                                        <div style={{ display: "inline-block" }}>
                                            <LabelTitle label={"Tidak Tuntas"} size={16} bolder={600} color={"#2A2B2A"} />
                                        </div>
                                    </div>
                                </div>
                                {dataIndicatorNumerasi.map((indicatorNumerasi, i) => {
                                    return (
                                        <div key={i}>
                                            <div style={styles.paddingHorizontal}>
                                                <div style={styles.indicator}>
                                                    <LabelTitle label={indicatorNumerasi.namaIndikator} size={16} bolder={300} color={"#6C757D"} />
                                                </div>
                                                <div style={styles.indicatorGreen}>
                                                    <div className="indikatorTuntas">
                                                        <LabelTitle label={indicatorNumerasi.tuntas} size={16} bolder={300} color={"#FFF"} />
                                                    </div>
                                                </div>
                                                <div style={styles.indicatorRed}>
                                                    <div className="indikatorTakTuntas">
                                                        <LabelTitle label={indicatorNumerasi.tidakTuntas} size={16} bolder={300} color={"#FFF"} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <Gap height={15} />
                <Gap height={30} />
                <FooterReport date={dateTime} />
            </div>
            {/* End Page One */}
            {/* Page Two */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>02</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Tes : {dataSchool.tanggal}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>Hasil Simulasi Asesmen Nasional Sekolah</div>
                            <div className="label-sub-tit" style={{ width: '405px' }}>
                                <span className="sub-title-header" style={{ color: '#FFF' }}>{dataSchool.kelas} - ({dataSchool.peserta} Siswa)</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                            </div>
                        </div>
                    </div>
                    <Gap height={40} />
                    {/* card survei karakter */}
                    <div className="card-profile">
                        <div className="title-card">Survei Karakter Test 1</div>
                        <div style={{ padding: '10px', width: '100%' }}>
                            {dataSurveyCharacter.map((surveyCharacter, i) => {
                                return (
                                    <div key={i}>
                                        <div className="pnl-loop-sk" style={{ padding: '0px' }}>
                                            <div className="section-four-left" style={{ width: '10%' }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <img
                                                        src={
                                                            surveyCharacter.aspek === "Kreatif"
                                                                ? "/assets/image/mdi_lightbulb.svg"
                                                                : surveyCharacter.aspek === "Gotong Royong"
                                                                    ? "/assets/image/mdi_people.svg"
                                                                    : surveyCharacter.aspek === "Bernalar Kritis"
                                                                        ? "/assets/image/mdi_hub.svg"
                                                                        : surveyCharacter.aspek === "Mandiri"
                                                                            ? "/assets/image/mdi_mandiri.svg"
                                                                            : surveyCharacter.aspek === "Beriman, Bertaqwa Kepada Tuhan YME dan Berakhlak Mulia"
                                                                                ? "/assets/image/mdi_religion-islamic.svg"
                                                                                : "/assets/image/mdi_earth.svg"
                                                        }
                                                        width={"100%"} style={{ width: '45px' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="section-four-right" style={{ width: '70%' }}>
                                                <div
                                                    style={{
                                                        display: "inline-block",
                                                        width: "85%",
                                                    }}
                                                >
                                                    <LabelTitle label={surveyCharacter.aspek} size={15} bolder={300} color={"#6C757D"} />
                                                </div>
                                                <ProgressBar progressValue={surveyCharacter.jumlah} progressColor={"#BEF264"} heightBar={23} />
                                            </div>
                                            <div className="section-four-right" style={{ width: '20%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {/* <LabelLevel
                                                    color={surveyCharacter.kategori === "Dasar" ? "#FF9914" : surveyCharacter.kategori === "Baik" ? "#2BA84A" : surveyCharacter.kategori === "Unggul" ? "#1B98E0" : "#D05353"}
                                                    bgColor={surveyCharacter.kategori === "Dasar" ? "#EEE5BF" : surveyCharacter.kategori === "Baik" ? "#BAF2D8" : surveyCharacter.kategori === "Unggul" ? "#BFDBF7" : "#F6CACC"}
                                                    level={surveyCharacter.kategori} label={'danggoreng'}
                                                /> */}
                                                <div className="indikatorTuntas" style={{ width: '120px', height: '35px' }}>
                                                    <span className="desc-indikator">{surveyCharacter.kategori}</span>
                                                </div>
                                            </div>
                                            <Gap height={20} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Gap height={40} />
                    {/* card survei lingkungan */}
                    <div className="card-profile" style={{padding: '20px'}}>
                        <div className="title-card">Survei Lingkungan Belajar Test</div>
                        <div style={{ padding: '10px', width: '100%' }}>
                            {dataSLB.map((dataSlb, i) => {
                                return (
                                    <div key={i}>
                                        <div className="pnl-loop-sk" style={{ padding: '0px' }}>
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    width: "85%",
                                                    paddingRight: "5%",
                                                }}
                                            >
                                                <LabelTitle label={dataSlb.aspek} size={16} bolder={500} color={"#6C757D"} />
                                                <Gap height={3} />
                                                <ProgressBar progressValue={dataSlb.jumlah} progressColor={"#BEF264"} heightBar={23} />
                                            </div>

                                            <div style={{ width: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            >
                                                {/* <LabelLevel
                                                color={dataSlb.kategori === "Cukup" ? "#FF9914" : dataSlb.kategori === "Baik" ? "#2BA84A" : dataSlb.kategori === "Sangat Baik" ? "#1B98E0" : "#D05353"}
                                                bgColor={dataSlb.kategori === "Cukup" ? "#EEE5BF" : dataSlb.kategori === "Baik" ? "#BAF2D8" : dataSlb.kategori === "Sangat Baik" ? "#BFDBF7" : "#F6CACC"}
                                                level={dataSlb.kategori}
                                            /> */}
                                                <div className="indikatorTuntas" style={{ width: '120px', height: '35px' }}
                                                    color={dataSlb.kategori === "Cukup" ? "#5446CD" : dataSlb.kategori === "Baik" ? "#03C46B" : dataSlb.kategori === "Sangat Baik" ? "#0097CE" : "#0097CE"}>
                                                    <span className="desc-indikator">{dataSlb.kategori}</span>
                                                </div>
                                            </div>

                                        </div>

                                        <Gap height={15} />
                                    </div>
                                );
                            })}

                        </div>

                    </div>
                    <Gap height={20} />
                </div>
                <Gap height={20} />
                <FooterReport date={dateTime} />
            </div>

            {/* End Page Two */}
            {/* Page Three */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>03</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Tes : {dataSchool.tanggal}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>Hasil Simulasi Asesmen Nasional Sekolah</div>
                            <div className="label-sub-tit" style={{ width: '405px' }}>
                                <span className="sub-title-header" style={{ color: '#FFF' }}>{dataSchool.kelas} - ({dataSchool.peserta} Siswa)</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                            </div>
                        </div>
                    </div>
                    <div className="title-card" style={{ fontSize: '20px', fontWeight: '700', lineHeight: '150%', letterSpacing: '0.06px' }}>Indeks Sosial - Ekonomi Siswa</div>
                    <Gap height={10} />
                    {/* card pendidikan ortu */}
                    <div className="card-profile">
                        <div className="title-card">Pendidikan Terakhir Orang Tua</div>
                        <div style={{ display: 'flex', width: '100%' }}>
                            <div style={{ width: '50%' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src="/assets/image/mdi_man.svg" width={"100%"} style={{ height: '33px', width: '30px' }} />
                                    <div>
                                        <span style={{ fontWeight: 400, fontSize: '18px' }}>Ayah</span>
                                    </div>
                                </div>
                                {dataFatherEducation.map((educationFather, i) => {
                                    return (
                                        <div key={i}>
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    width: "100%",
                                                    paddingRight: "5%",
                                                }}
                                            >
                                                <LabelTitle label={educationFather.namaKategori} size={16} bolder={500} color={"#6C757D"} />
                                                <Gap height={3} />
                                                <ProgressBar progressValue={educationFather.jumlah} progressColor={"#03C46B"} heightBar={23} />
                                            </div>
                                            <Gap height={15} />
                                        </div>
                                    );
                                })}
                            </div>
                            <div style={{ width: '50%' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src="/assets/image/mdi_woman.svg" width={"100%"} style={{ height: '33px', width: '30px' }} />
                                    <div>
                                        <span style={{ fontWeight: 400, fontSize: '18px' }}>Ibu</span>
                                    </div>
                                </div>
                                {dataMotherEducation.map((educationMother, i) => {
                                    return (
                                        <div key={i}>
                                            <div
                                                style={{
                                                    display: "inline-block",
                                                    width: "100%",
                                                    paddingRight: "5%",
                                                }}
                                            >
                                                <LabelTitle label={educationMother.namaKategori} size={16} bolder={500} color={"#6C757D"} />
                                                <Gap height={3} />
                                                <ProgressBar progressValue={educationMother.jumlah} progressColor={"#FF3838"} heightBar={23} />
                                            </div>
                                            <Gap height={15} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Gap height={20} />
                    {/* card fasilitas */}
                    <div className="card-profile">
                        <div className="title-card">Fasilitas Rumah</div>
                        <div className="flex-fasilitas">
                            {dataHomeFacility.map((homeFacility, i) => {
                                return (
                                    <div key={i} className="card-fasilitas">
                                        <div>
                                            <div
                                                style={{
                                                    backgroundColor: "#015E56",
                                                    width: 35,
                                                    paddingBottom: 5,
                                                    paddingTop: 5,
                                                    textAlign: "center",
                                                    color: "#fff",
                                                    fontSize: '18px',
                                                    borderRadius: 20,
                                                }}
                                            >
                                                {homeFacility.jumlah}
                                            </div>
                                        </div>
                                        <img
                                            src={
                                                homeFacility.namaKategori === "Mobil/Kendaraan roda empat"
                                                    ? "/assets/image/mdi_car.svg"
                                                    : homeFacility.namaKategori === "Mobil/Kendaraan roda dua"
                                                        ? "/assets/image/mdi_motor.svg"
                                                        : homeFacility.namaKategori === "Kamar tidur untuk diri sendiri (tidak sekamar dengan saudara kandung atau orang tua atau orang lain)"
                                                            ? "/assets/image/mdi_bed.svg"
                                                            : homeFacility.namaKategori === "Pendingin Ruangan (AC)"
                                                                ? "/assets/image/mdi_ac.svg"
                                                                : homeFacility.namaKategori === "Komputer/Laptop"
                                                                    ? "/assets/image/mdi_laptop.svg"
                                                                    : homeFacility.namaKategori === "HP/tablet/smartphone/i-pad"
                                                                        ? "/assets/image/mdi_phone.svg"
                                                                        : homeFacility.namaKategori === "Wifi"
                                                                            ? "/assets/image/mdi_wifi.svg"
                                                                            : "/assets/image/mdi_device.svg"
                                            }
                                            width={"25%"}
                                        />
                                        <Gap height={10} />
                                        <div>
                                            {/* <LabelTitle label={homeFacility.namaKategori.substring(0, 30)} size={15} bolder={400} color={"#6C757D"} /> */}
                                            <span className="desc-fasilitas">{homeFacility.namaKategori.substring(0, 30)}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <Gap height={20} />
                <FooterReport date={dateTime} />
            </div>
            
            {/* End :: Page Two */}
            <div style={styles.fixedButton}>
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default ReportSekolah;

const styles = {
    resultBar: {
        display: "inline-block",
        width: "85%",
        textAlign: "right",
        fontWeight: 700,
        marginTop: 10,
    },
    valueResultBar: {
        display: "inline-block",
        width: "15%",
        textAlign: "right",
        fontWeight: 700,
        marginTop: 10,
    },
    indicatorBg: {
        backgroundColor: "#ccd1e4",
        borderRadius: "10px",
        padding: "12px",
        marginBottom: 10,
    },
    indicatorLabel: {
        display: "inline-block",
        width: "50%",
    },
    indicatorType: {
        display: "inline-block",
        width: "50%",
        textAlign: "right",
    },
    indicatorValue: {
        display: "inline-block",
        width: "85%",
    },
    indicatorStatus: {
        display: "inline-block",
        width: "15%",
    },
    indicator: {
        display: "inline-block",
        width: "50%",
    },
    indicatorGreen: {
        display: "inline-block",
        width: "25%",

    },
    indicatorRed: {
        display: "inline-block",
        width: "25%",
    },
    paddingHorizontal: {
        padding: "15px",
        // paddingRight: "12px",
    },
    fixedButton: {
        position: "fixed",
        bottom: "20px",
        right: "0px",
        height: "auto",
        padding: "15px",
        zIndex: 99,
        // -webkit-transform: translate3d(0, 0, 0),
        transition: "all 0.25s ease",
        textAlign: "center",
    },
};
